module.exports = __webpack_public_path__ + "images/2b39f330b68b67ff39adf802ef38fb2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/components/QuoteSidebar/img/cc1.jpg
// module id = 1380
// module chunks = 0